module.exports = {
        srcSet: __webpack_public_path__ + "static/media/mieter-netzwerk-mobile-640.edd8840e.webp"+" 640w",
        images: [{path: __webpack_public_path__ + "static/media/mieter-netzwerk-mobile-640.edd8840e.webp",width: 640,height: 359}],
        src: __webpack_public_path__ + "static/media/mieter-netzwerk-mobile-640.edd8840e.webp",
        toString: function(){return __webpack_public_path__ + "static/media/mieter-netzwerk-mobile-640.edd8840e.webp"},
        
        width: 640,
        height: 359
      }